export default ($) => {
  let $_pathways   = $('._pathways');

  $_pathways.each(function () {
    let $_pathway = $(this);

    let $tabTriggers   = $_pathway.find('.js-tabTrigger');
    let $selectTrigger = $_pathway.find('.js-tabSelectTrigger');
    let $tabData       = $_pathway.find('.js-tabData');

    $tabTriggers.on('click', function () {
      let _this = $(this);
      let pathway = _this.attr('data-pathway');

      $tabTriggers.removeClass('-active');
      $tabData.hide();

      _this.addClass('-active');
      $_pathway.find(`[data-pathway="${pathway}"]`).show();

      let $listItem = $_pathway.find(`.select-options li[rel=${pathway}]`);
      $listItem.click();
    });

    $selectTrigger.on('change', function () {
      let _this = $(this);
      let pathway = _this.find('option:selected').val();

      $tabTriggers.removeClass('-active');
      $tabData.hide();

      $_pathway.find(`.js-tabTrigger[data-pathway="${pathway}"]`).addClass('-active');
      $_pathway.find(`[data-pathway="${pathway}"]`).show();
    });
  });
}